import { render, staticRenderFns } from "./RemindersList.vue?vue&type=template&id=d5039080"
import script from "./RemindersList.vue?vue&type=script&lang=js"
export * from "./RemindersList.vue?vue&type=script&lang=js"
import style0 from "./RemindersList.vue?vue&type=style&index=0&id=d5039080&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports